import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXL } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

const Wrapper = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  align-content: center;
  justify-content: center;
  isolation: isolate;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: var(--c-nl-700);
    z-index: -1;
  }
`;

type Props = {
  children: ReactNode;
  onClose: () => void;
};

export const Reward = ({ children, onClose }: Props) => {
  return (
    <Wrapper onClick={onClose}>
      <Vertical center gap={3}>
        <BrandXL className="text-center">
          <FormattedMessage id="Reward.youWon" defaultMessage="You've won:" />
        </BrandXL>
        {children}
        <Button color="purple" size="large" onClick={onClose}>
          <FormattedMessage {...glossary.ok} />
        </Button>
      </Vertical>
    </Wrapper>
  );
};
